// extracted by mini-css-extract-plugin
export var chatHtmlText = "_p4-2";
export var chatLink = "_p4-0";
export var chatText = "_p4-1";